import React from 'react';
import PropTypes from 'prop-types';

import {
  TextInput,
} from '../../../fragments/forms';
import Messages from '../../../fragments/messages';


import style from './style.css';


export default class NonPubmed extends React.Component {

  static propTypes = {
    reference: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  constructor() {
    super(...arguments);
    this.state = {
      url: '',
      dataSource: '',
    };
  }

  handleUpdate(fieldName) {
    if (fieldName === 'url') {
      return this.handleUpdateURL.bind(this);
    } else if (fieldName === 'dataSource') {
      return this.handleUpdateDataSource.bind(this);
    }
  }

  handleUpdateURL(url) {
    this.setState({
      url
    });
    const {dataSource} = this.state;
    this._handleUpdate(url, dataSource);
  }

  handleUpdateDataSource(dataSource) {
    this.setState({
      dataSource,
    });
    const {url} = this.state;
    this._handleUpdate(url, dataSource);
  }

  _handleUpdate(url, dataSource) {
    let nonMedlineDesc = '';
    if (!dataSource  && !url) {
      return;
    } else if (dataSource && !url) {
      nonMedlineDesc = dataSource;
    } else if (!dataSource && url) {
      nonMedlineDesc = `<a href="${url}">${url}</a>`;
    } else {
      nonMedlineDesc = `<a href="${url}">${dataSource}</a>`;
    }

    const {reference} = this.props;

    // if (!reference.authors) {
    //   return
    // }

    const authors_list = reference.authors.map(({lastname, initials}) => {
      return `${lastname} ${initials}`;
    }).join(',');
    const title = reference.title;
    nonMedlineDesc = `${authors_list}. ${title}. ${nonMedlineDesc}`;

    reference.nonMedlineDesc = nonMedlineDesc;
    const {onUpdate} = this.props;
    onUpdate(reference);
  }

  get allMessage() {
    const {reference, showError} = this.props;

    return reference.messages('medlineId', showError);

  }

  render() {
    const {readOnly, reference} = this.props;
    const {url, dataSource} = this.state;
    const messages = this.allMessage;

    if (!reference || reference.medlineId) {
      return null;
    }

    return (
      <div>
        <div className={style.datasource}>
          <TextInput
           name="dataSource"
           label="Data source"
           readOnly={readOnly}
           value={dataSource}
           onChange={this.handleUpdate('dataSource')}
          />
          <span>{' '}at{' '}</span>
          <TextInput
           name="url"
           label="URL"
           readOnly={readOnly}
           value={url}
           onChange={this.handleUpdate('url')}
          />
        </div>
        {messages.length ? <Messages messages={messages} /> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-edit/non-pubmed.js